import React, { useMemo } from 'react';
import { SecondaryMetric, ProgressBarWithLegends } from '@frontend/app/refresh-components';
import { Skeleton } from '@frontend/shadcn/components/ui/skeleton';
import { WalletIcon } from '@revfluence/fresh-icons/solid/esm';
import { ProjectWidgetContainer } from '../common/ProjectWidgetContainer';

interface TotalBudgetCardProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  budgetData: any;
  isLoading: boolean;
}

export const TotalBudgetCard = ({ budgetData, isLoading }: TotalBudgetCardProps) => {
  const legend = useMemo(
    () => [
      { label: 'Spend', color: '#1E4945', percent: budgetData?.totalBudget?.usedPercent || 0 },
      { label: 'Remaining', color: '#E5E8EB', percent: budgetData?.totalBudget?.availablePercent || 0 },
    ],
    [budgetData],
  );

  if (isLoading) {
    return (
      <ProjectWidgetContainer
        title="Total Budget"
        icon={<WalletIcon className="w-4 h-4" />}
        tooltip="Total budget allocated for this project"
        className="!w-full h-full"
      >
        <div className="w-full h-full flex flex-col justify-center items-center">
          <Skeleton className="h-6 w-full mb-4" />
          <Skeleton className="h-6 w-full mb-4" />
          <Skeleton className="h-4 w-full" />
        </div>
      </ProjectWidgetContainer>
    );
  }

  return (
    <ProjectWidgetContainer
      title="Total Budget"
      icon={<WalletIcon className="w-4 h-4" />}
      tooltip="Total budget allocated for this project"
      className="!w-full h-full"
    >
      <div className="w-full h-full flex flex-col justify-between">
        <div className="flex justify-between w-full">
          <SecondaryMetric
            value={budgetData?.totalBudget?.totalAmount || 0}
            size="small"
            metricType="currency"
          />
          <SecondaryMetric
            value={budgetData?.totalBudget?.availableAmount || 0}
            size="small"
            metricType="currency"
            heading="Budget Remaining"
          />
        </div>
        <div className="w-full">
          <ProgressBarWithLegends edge="square" legend={legend} height={15} />
        </div>
      </div>
    </ProjectWidgetContainer>
  );
};
